import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BreakdownTechnician, Driver, FleetClient, LinkServiceProviderRequest, MergeFleetRequest, PricingTemplate, SavedLocation, ServiceProviderGroupedList, Transporter, Vehicle } from '../models/client';
import { environment } from '../../environments/environment';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  apiUrl = 'v1/client/';

  constructor(private http: HttpClient) { }


  public upsertSavedLocation(location: SavedLocation) {
    return this.http.post<SavedLocation>(`${environment.apiUrl + this.apiUrl}savedlocation`, location);
  }

  public fleetTruckDrivers(clientId: number) {
    return this.http.get<Driver[]>(`${environment.apiUrl + this.apiUrl}${clientId}/truckdriver`);
  }

  public breakdownTechnicians(clientId: number) {
    return this.http.get<BreakdownTechnician[]>(`${environment.apiUrl + this.apiUrl}${clientId}/breakdowntechnician`);
  }

  public addFleetTruckDriver(clientId: number, driver: Driver) {
    return this.http.post<Driver>(`${environment.apiUrl + this.apiUrl}${clientId}/truckdriver`, driver);
  }

  public fleetVehicles(clientId: number) {
    return this.http.get<Vehicle[]>(`${environment.apiUrl + this.apiUrl}${clientId}/fleetvehicle`);
  }

  public addFleetVehicle(clientId: number, vehicle: Vehicle) {
    return this.http.post<Vehicle>(`${environment.apiUrl + this.apiUrl}${clientId}/fleetvehicle`, vehicle);
  }

  public getPricingTemplates(clientId: number) {
    return this.http.get<PricingTemplate[]>(`${environment.apiUrl + this.apiUrl}${clientId}/pricingtemplates`);
  }

  public upsertFleet(clientId: number, fleetClient: FleetClient) {
    return this.http.post<FleetClient>(`${environment.apiUrl + this.apiUrl}${clientId}/fleet`, fleetClient);
  }

  public updateBreakdownTechnicianStatus(technicianId: number, statusId: number) {
    return this.http.post<BreakdownTechnician[]>(`${environment.apiUrl + this.apiUrl}technician/${technicianId}/status/${statusId}`, {});
  }

  public upsertTechnician(technician: User) {
    return this.http.post<BreakdownTechnician>(`${environment.apiUrl + this.apiUrl}technician`, technician);
  }

  public getFleetClients() {
    return this.http.get<FleetClient[]>(`${environment.apiUrl + this.apiUrl}fleets/list`);
  }

  public removeFleetClient(clientId: number) {
    return this.http.delete<void>(`${environment.apiUrl + this.apiUrl}fleets/${clientId}`);
  }

  public removeDriver(clientId: number, driverId: number) {
    return this.http.delete<void>(`${environment.apiUrl + this.apiUrl}fleets/${clientId}/driver/${driverId}`);
  }

  public removeVehicle(clientId: number, vehicleId: number) {
    return this.http.delete<void>(`${environment.apiUrl + this.apiUrl}fleets/${clientId}/vehicle/${vehicleId}`);
  }

  public mergeFleets(request: MergeFleetRequest) {
    return this.http.post<FleetClient>(`${environment.apiUrl + this.apiUrl}fleets/merge`, request);
  }

  public getTransporters() {
    return this.http.get<Transporter[]>(`${environment.apiUrl + this.apiUrl}transporter`);
  }

  public getServiceProviderGroupedList() {
    return this.http.get<ServiceProviderGroupedList>(`${environment.apiUrl + this.apiUrl}service-provider/all`);
  }

  public linkServiceProviderToSelf(serviceProviderId: number, linkRequest: LinkServiceProviderRequest) {
    return this.http.post<ServiceProviderGroupedList>(`${environment.apiUrl + this.apiUrl}service-provider/${serviceProviderId}/link`, linkRequest);
  }


}
